import { StyleSheet } from 'aphrodite';
import { titles } from '../../../../../web/styles/colors';

const TabsHeight = 70;
const HeaderHeight = 36;
const InterItemSpacing = 30;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	header: {
		alignItems: 'flex-start',
		color: titles,
		display: 'flex',
		fontSize: 16,
		height: HeaderHeight,
		marginBottom: InterItemSpacing,
		flex: 'none',
	},
	selectAllContainer: {
		marginBottom: 10,
		flex: 'none',
	},
	selectAllSpan: {
		textTransform: 'uppercase',
	},
	selectedTab: {
		background: '#E8F3F9',
	},
	tab: {
		alignItems: 'center',
		boxSizing: 'border-box',
		color: '#4A4A4A',
		display: 'flex',
		flexGrow: 1,
		fontSize: 14,
		justifyContent: 'center',
		padding: '0 20px',
		textAlign: 'center',
		whiteSpace: 'pre-wrap',
	},
	tabs: {
		border: '1px solid #F2F2F2',
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.10)',
		display: 'flex',
		height: TabsHeight,
		justifyContent: 'space-evenly',
		marginBottom: InterItemSpacing,
	},
	tabsBackground: {
		height: '100%',
		width: '100%',
	},
	usersList: {
		flex: 1,
		overflowY: 'auto',
		minHeight: 0,
		position: 'relative',
	},
	usersListRow: {},
});
